import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, ChevronRight, CalendarDays, ArrowRight } from "lucide-react";
import { Sheet, SheetContent, SheetTitle, SheetDescription } from "../ui/sheet";
import { Logo } from "./Logo";
import { NAV_MAIN, NAV_EXTRA } from "../../i18n/fr";

const PanelLinks = ({ items, onClose, prefix }) => (
  <ul className="divide-y divide-[#EDE3D9]">
    {items.map((it) => (
      <li key={it.to}>
        <Link to={it.to} onClick={onClose} data-testid={`${prefix}-${it.testid}`}
          className="flex items-center justify-between py-3.5 text-[#242020] hover:text-[#650D23] transition-colors">
          <span>{it.label}</span><ChevronRight className="h-4 w-4 text-[#650D23]" />
        </Link>
      </li>
    ))}
  </ul>
);

export const Header = () => {
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);
  return (
    <header className="sticky top-0 z-50 border-b border-[#EDE3D9]/70 bg-[#FFFDFB]/85 backdrop-blur-md" data-testid="site-header">
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-6 px-5 py-4 sm:px-8 lg:px-12">
        <Logo />
        <nav className="hidden items-center gap-5 lg:flex" aria-label="Navigation principale">
          {NAV_MAIN.map((it) => (
            <NavLink key={it.to} to={it.to} end data-testid={it.testid}
              className={({ isActive }) => `relative py-1 text-[0.82rem] transition-colors hover:text-[#650D23] ${isActive ? "text-[#650D23] after:absolute after:-bottom-1 after:left-0 after:h-[2px] after:w-full after:bg-[#650D23]" : "text-[#242020]"}`}>
              {it.label}
            </NavLink>
          ))}
        </nav>
        <button onClick={() => setOpen(true)} data-testid="nav-hamburger-button" aria-label="Ouvrir le menu"
          className="flex h-12 w-12 items-center justify-center rounded-full bg-[#650D23] text-[#FFFDFB] transition-colors hover:bg-[#4A0C1B]">
          <Menu className="h-5 w-5" />
        </button>
      </div>
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="right" className="w-full overflow-y-auto border-l-[#EDE3D9] bg-[#FFFDFB] p-0 sm:max-w-md" data-testid="nav-panel">
          <div className="px-8 pb-6 pt-8"><Logo testid="nav-panel-logo" /></div>
          <SheetTitle className="sr-only">Menu</SheetTitle>
          <SheetDescription className="sr-only">Navigation du site STRUKTIV</SheetDescription>
          <div className="space-y-6 px-8">
            <PanelLinks items={NAV_MAIN} onClose={close} prefix="panel" />
            <p className="eyebrow pt-2">Explorer</p>
            <PanelLinks items={NAV_EXTRA} onClose={close} prefix="panel" />
          </div>
          <div className="mt-8 bg-[#650D23] px-8 py-8 text-[#FFFDFB]">
            <div className="flex items-start gap-4">
              <CalendarDays className="mt-1 h-7 w-7 shrink-0" />
              <p className="text-sm leading-relaxed">Une question? Planifions une consultation.</p>
            </div>
            <Link to="/consultation" onClick={close} data-testid="panel-cta-consultation" className="btn-light mt-6">
              Prendre rendez-vous <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
        </SheetContent>
      </Sheet>
    </header>
  );
};
